export { default as VictoryArea } from "./victory-area";
export { default as Area } from "./area";